/**
 * FeedbackAnswerState
 *
 * | |
 * |---|
 * | `presented` <br/> The question was shown, but no final outcome has been recorded yet. |
 * | `answered` <br/> The participant submitted a valid answer. |
 * | `omitted` <br/> The participant intentionally continued without answering an optional question. |
 * | `timed_out` <br/> A presented one-by-one question reached its time limit before the participant submitted an answer. |
 */
export enum FeedbackAnswerState {
    PRESENTED = 'presented',
    ANSWERED = 'answered',
    OMITTED = 'omitted',
    TIMED_OUT = 'timed_out'
}
